import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const productCardsContainerStyles = makeStyles((theme: Theme) =>
    createStyles({
        titlesSection: {
            textAlign: 'center',
            '& h1': {
                fontFamily: 'Cormorant Garamond',
                fontSize: '50px',
                marginBottom: '20px'
            },
            '& span': {
                fontFamily: 'Hind Siliguri',
                fontSize: '35px',
                fontWeight: 'lighter'
            },
            [theme.breakpoints.down('xs')]: {
                '& h1': {
                    fontSize: '42px',
                },
                '& span': {
                    fontSize: '30px',
                },
            }
        },
        cardsCarousel: {
            marginBottom: '2.5rem'
        },
        gridMainContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }
        },
    })
);

export default productCardsContainerStyles;

